import { render, staticRenderFns } from "./clashofwars.vue?vue&type=template&id=23895fdd&scoped=true"
import script from "./clashofwars.vue?vue&type=script&lang=js"
export * from "./clashofwars.vue?vue&type=script&lang=js"
import style0 from "./clashofwars.vue?vue&type=style&index=0&id=23895fdd&prod&scoped=true&lang=css"
import style1 from "./clashofwars.vue?vue&type=style&index=1&id=23895fdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23895fdd",
  null
  
)

export default component.exports